import axios from 'axios';
import { $attr, $closest, $find, $qs, $setAttr, $val } from 'fxdom/es';
import { extend, find, go, head, map, reject, split } from 'fxjs/es';
import '../../../../../../../www/module/front/app/mp/mp.checkout.js';
import { NessOutboundF } from '../../../../../../Ness/Outbound/F/Function/module/NessOutboundF.js';
import { UtilImageS } from '../../../../../../Util/Image/S/Function/module/UtilImageS.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopUtilF } from '../../../../../Util/F/Function/module/MShopUtilF.js';
import { MShopAppStoreCommunityConstantS } from '../../../../Store/Community/S/Constant/module/MShopAppStoreCommunityConstantS.js';
import { Alert } from '../../../../../../../services/MarppleShop/renderApp/components/cells/Alert/Alert.ts';

export const changeEmail = async (e) => {
  const { data } = await axios.get(`/${T.lang}/@api/get/user`);
  if (!data?.result) {
    return Alert.open({
      title: '',
      message: T('my_info::There is no user information. Please log in again after login.'),
    });
  }

  $.frame.open(
    {
      frame_name: 'mp.checkout.change_email',
      closed: function (X, data) {
        if (!data || !data.result) return;
        window.location.reload();
      },
    },
    {
      tabs: [
        {
          page_name: 'mp.checkout.change_email',
          data_func: function () {
            return data.user;
          },
        },
      ],
    },
  );
};

export const changePassword = async (e) => {
  try {
    const input_email = box.sel('is_user->email');
    if (!UtilS.is_valid_email(input_email)) {
      await Alert.open({
        title: '',
        message: T('my_info::This email address is not available.'),
      });
    }

    const { data } = await axios.post(`/${T.lang}/@api/mp/reset_password`, {
      email: G.to_lower(input_email),
      url: `/${T.lang}/@/mypage`,
    });

    if (!data.result) {
      return Alert.open({
        title: '',
        message: T('Reset password failed'),
      });
    }

    return Alert.open({
      title: '',
      message: T('Check your email for a link'),
    });
  } catch (_err) {
    return Alert.open({
      title: '',
      message: T('Reset password failed'),
    });
  }
};

export const modify = async (e) => {
  try {
    const name_el = $find('input[name="name"]', e.delegateTarget);
    const mobile_el = $find('input[name="mobile"]', e.delegateTarget);
    const birthday_el = $find('input[name="birthday"]', e.delegateTarget);
    const checked_gender_el = $find('input[name="gender"]:checked', e.delegateTarget);
    const checked_agree_email_el = $find('input[name="agree_email"]:checked', e.delegateTarget);

    if (UtilS.is_empty($val(name_el))) {
      await Alert.open({
        title: '',
        message: T('Name is empty'),
      });

      name_el.focus();
      return;
    }

    if (UtilS.is_special_str($val(name_el))) {
      await Alert.open({
        title: '',
        message: T('my_info::Only Numbers and Text'),
      });
      name_el.focus();
      return;
    }

    if ($val(birthday_el).length > 0 && $val(birthday_el).length != 8) {
      await Alert.open({
        title: '',
        message: T('my_info::ex) 19940203'),
      });
      birthday_el.focus();
      return;
    }

    // if ($val(birthday_el).length > 0 && !UtilS.is_number($val(birthday_el))) {
    //   return go(T('my_info::Only Numbers'), $.alert, function () {
    //     birthday_el.focus();
    //   });
    // }

    if (T.lang == 'kr' && $val(mobile_el).length > 0 && !UtilS.isKrTelNumber($val(mobile_el))) {
      await Alert.open({
        title: '',
        message: T('my_info::Only Numbers'),
      });

      mobile_el.focus();
      return;
    }

    $.don_loader_start();
    const { data } = await axios.post(
      `/${T.lang}/@api/my_account/modify`,
      extend(
        {
          user_id: box.sel('is_user->id'),
          name: $val(name_el),
          birthday: $val(birthday_el) || '',
          gender: checked_gender_el && $val(checked_gender_el),
          agree_email: checked_agree_email_el.value == 'true',
        },
        T.lang == 'kr' && {
          mobile: T.lang == 'kr' ? $val(mobile_el) : '',
        },
      ),
    );

    if (!data.result) {
      $.don_loader_end();
      return MShopUtilF.popToastMsg(data.msg || T('community::실패'), 'error');
    }
    $.don_loader_end();

    MShopUtilF.popToastMsg(T('my_info::Changed'), 'confirm');
  } catch (_e) {
    $.don_loader_end();
    MShopUtilF.popToastMsg(T('community::실패'), 'error');
  }
};

export const profileModify = async (e) => {
  const is_ness = UtilS.isNessApp();
  try {
    $.don_loader_start();
    const $wrapper = $closest('.my-account', e.currentTarget);
    if (!$wrapper) throw new Error();
    const profile_image_input_element = $find('.my-account__profile_image__upload input', $wrapper);
    const profile_preview_element = $find('.my-account__profile_image__preview img', $wrapper);

    if (profile_preview_element.dataset.delete !== 'true' && !profile_image_input_element.files.length)
      throw new Error(ET('community::community_01'));

    const form_data = new FormData();
    if (profile_image_input_element.files.length) {
      await go(profile_image_input_element.files, head, (file) =>
        form_data.append('files[]', file, file.name),
      );
    }

    await axios.post(`/${T.lang}/@api/my_account/profile_modify`, form_data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    $.don_loader_end();
    !is_ness && MShopUtilF.popToastMsg(T('my_info::Changed'), 'confirm');
  } catch (_e) {
    $.don_loader_end();
    MShopUtilF.popToastMsg(_e?.response?.data?.message || _e.message || T('community::실패'), 'error');
  }
};

export const changeProfileImage = async (e) => {
  try {
    const $input = e.currentTarget;
    const $wrapper = $closest('.my-account__profile_image', e.currentTarget);
    const profile_upload_text_el = $find('.my-account__profile_image__upload-text', $wrapper);
    $input.disabled = true;

    const accepts = go($input, $attr('accept'), split(','), map(UtilS.lowerCase));

    const invalid = go(
      $input.files,
      find((file) => {
        const extension = (file.name.match(/\.[^/.]+$/) || [''])[0].toLowerCase();
        return accepts.indexOf(file.type) === -1 && accepts.indexOf(extension) === -1;
      }),
    );

    if (invalid) {
      $input.files = reject((file) => file.lastModified === invalid.lastModified, $input.files);
      throw new Error();
    }

    $.don_loader_start();
    await go($input.files, head, async (file) => {
      const data_uri = await $.get_data_url(160)(file);
      const profile_image$ = $find('img', $wrapper);
      const profile_image_delete$ = $find('.my-account__profile_image__delete', $wrapper);
      $setAttr({ src: data_uri, loaded: true }, profile_image$);
      profile_image$.dataset.delete = 'false';
      if (profile_image_delete$) profile_image_delete$.dataset.active = true;

      if (profile_upload_text_el) {
        profile_upload_text_el.innerText = ET('my_page::my_account_07');
      }
    });

    $input.disabled = false;
    $.don_loader_end();
  } catch (_e) {
    $.don_loader_end();
    MShopUtilF.popToastMsg(T('community::실패'), 'error');
  }
};

export const deleteProfileImage = (e) => {
  try {
    const $delete_button = e.currentTarget;
    const $wrapper = $closest('.my-account__profile_image', e.currentTarget);
    const profile_image$ = $find('img', $wrapper);
    const $input = $find('input[type="file"][name="file"]', $wrapper);
    const profile_upload_text_el = $find('.my-account__profile_image__upload-text', $wrapper);

    if (profile_image$) {
      $setAttr(
        {
          src: UtilImageS.getResizedUrl({
            url: MShopAppStoreCommunityConstantS.EMPTY_USER_IMG,
            quality: 100,
            width: 192,
            format: 'webp',
          }),
          loaded: true,
        },
        profile_image$,
      );

      profile_image$.dataset.delete = 'true';
    }
    if ($input) $input.value = null;
    if ($delete_button) $delete_button.dataset.active = 'false';

    if (profile_upload_text_el) {
      profile_upload_text_el.innerText = ET('my_page::my_account_08');
    }
  } catch (_e) {
    MShopUtilF.popToastMsg(T('community::실패'), 'error');
  }
};

const rerenderUserInfo = ({ new_profile_image, is_delete_profile }) => {
  const $profile_img = $qs('.mypage-user__pic > img');

  if (is_delete_profile && $profile_img) {
    return ($profile_img.src = UtilImageS.getResizedUrl({
      url: MShopAppStoreCommunityConstantS.EMPTY_NESS_USER_IMG,
      quality: 100,
      width: 400,
      format: 'webp',
    }));
  }

  if (new_profile_image && $profile_img) {
    $profile_img.src = new_profile_image;
  }
};

export const changeProfileImageWithFetch = async (e) => {
  try {
    const is_mobile = MShopUtilF.isMobile();

    $.don_loader_start();
    const $wrapper = $closest('.my-account', e.currentTarget);
    if (!$wrapper) throw new Error();

    const $img = $find('img', $wrapper);
    const $input = $find('input[type="file"][name="file"]', $wrapper);

    const is_new_profile = $img.dataset.delete !== 'true' && $input.files.length;
    const is_delete_profile = $img.dataset.delete === 'true';

    const form_data = new FormData();
    if ($input.files.length) {
      await go($input.files, head, (file) => form_data.append('files[]', file, file.name));
    }

    const profile_modify_url = UtilS.makeApiUrl('/:lang/@api/my_account/profile_modify', {
      lang: ET.lang,
    });

    const { data: modify_user_profile_res } =
      is_new_profile || is_delete_profile
        ? await axios.post(profile_modify_url, form_data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
        : { data: { new_profile_image: null } };

    if (!modify_user_profile_res) {
      return MShopUtilF.popToastMsg(T('community::실패'), 'error');
    }

    await changeProfileImage(e);

    const new_profile_image = modify_user_profile_res.new_profile_image;
    !is_mobile && rerenderUserInfo({ new_profile_image, is_delete_profile });

    return MShopUtilF.popToastMsg(ET('ness::my_page::change_profile'), 'image');
  } catch (e) {
    const texts = {
      file_valid_5mb: ET('my_page::file_valid_5mb'),
      file_valid_fail: ET('my_page::file_valid_fail'),
    };
    if (e?.response?.data?.message && e?.response?.data?.message?.indexOf('File too large') != -1) {
      MShopUtilF.popToastMsg(texts.file_valid_5mb, 'error');
    } else {
      MShopUtilF.popToastMsg(texts.file_valid_fail, 'error');
    }
  } finally {
    $.don_loader_end();
  }
};

export const deleteProfileImageWithFetch = async (e) => {
  try {
    const is_mobile = MShopUtilF.isMobile();

    deleteProfileImage(e);
    await profileModify(e);
    !is_mobile && rerenderUserInfo({ is_delete_profile: true });
    return MShopUtilF.popToastMsg(ET('ness::my_page::delete_profile'), 'image');
  } catch (e) {
    MShopUtilF.popToastMsg(T('community::실패'), 'error');
  }
};

export const moveToNexonForModify = () => {
  NessOutboundF.goAccountEdit();
};
